export default __webpack_public_path__ + "static/media/check.73e9835a.svg";